import axios from "axios";
import {gatewayUrl} from "utils/config";

const axiosInstance = axios.create({
    baseURL: gatewayUrl,
    timeout: 30000,
});

axiosInstance.interceptors.request.use((config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  });

export default axiosInstance;